import { ShopDefinition } from "./ShopDefinition";

export class AccessChannelsModel {
	shops: ShopDefinition[];

	constructor(shopsArray: ShopDefinition[]) {
		this.shops = shopsArray;
	}
}
